import React, { useState } from "react"
import { Alert } from "@amzn/awsui-components-react";
import { MultiAllocationSheetValidationData } from "src/models/multidimensional-allocation/MultiAllocationSheetDetails";

export interface MDASheetViewErrorBannerProps {
    validationSummary: MultiAllocationSheetValidationData
}

export function MDASheetViewErrorBanner(props: MDASheetViewErrorBannerProps) {

    const errors = props.validationSummary.validationErrors || [];
    const [visible, setVisible] = useState(true)

    if(errors.length === 0) {
        return null;
    }

    let uniqueErrors = [...(new Set<string>(errors.map(err => err.message)))]

    let errorItems = uniqueErrors.map((err) => {
                return <li> { err } </li>   
            })

    return visible ? 
    <Alert
        dismissible
        onDismiss={() => setVisible(false)}
        header={'Validation Failed'}
        type="error"
    >
        {'We found the following issues in your uploaded file:'}
        <ul>
            {errorItems}
        </ul>
        {'You can make the necessary corrections in your file offline and upload again.'}
    </Alert>
    : 
    null;
}